import {
  CUSTOMER_ORDER_STATUSES,
  type CustomerOrder,
  type CustomerOrderStatus,
  customerOrderStatus,
  type Project,
} from '@noconflict/contracts';

/**
 * A project's status as a customer is told it: the same five wordings the Orders page shows for an order
 * (`customerOrderStatus` in contracts, `customer_order_status` in SQL), so the project page, the project list and
 * the Orders page never disagree. A project with no live order reads from its own status.
 */
export const CUSTOMER_STATUSES = CUSTOMER_ORDER_STATUSES;
export type CustomerStatus = CustomerOrderStatus;

export function customerStatus(
  project: Pick<Project, 'status'>,
  order: Pick<CustomerOrder, 'status'> | null,
): CustomerStatus {
  if (order) return customerOrderStatus(order.status, project.status);
  return project.status === 'draft' ? 'draft' : customerOrderStatus('placed', project.status);
}

/** The status badge tone of each customer status. */
export const CUSTOMER_STATUS_TONE = {
  draft: 'neutral',
  awaiting_payment: 'warning',
  in_progress: 'info',
  delivered: 'success',
  cancelled: 'danger',
} as const;

/** A draft the customer can still continue or discard: a project whose order has not been submitted. */
export function isOpenDraft(
  project: Pick<Project, 'status'>,
  order: Pick<CustomerOrder, 'status'> | null,
): boolean {
  return customerStatus(project, order) === 'draft';
}
